import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import './Contact.css';
import SEO from '../components/SEO';

const ContactPage = () => {
    return (
        <main className="contact-gallery">
            <SEO
                title="Contact Us"
                description="Get in touch with Vision Sports Academy at Fife Avenue Mall, Harare. Call or WhatsApp us for enrollment and inquiries."
            />
            {/* Hero Section */}
            <header className="contact-gallery__hero" style={{
                backgroundImage: `linear-gradient(rgba(11, 28, 45, 0.8), rgba(11, 28, 45, 0.8)), url(${require('../Images/hero-bg.jpeg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div className="container">
                    <motion.h1
                        className="contact-gallery__title"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        GET IN <span className="contact-gallery__title--accent">TOUCH</span>
                    </motion.h1>
                    <motion.p
                        className="contact-gallery__location"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        Harare, Zimbabwe
                    </motion.p>
                </div>
            </header>

            {/* Main Content */}
            <section className="contact-gallery__content">
                <div className="contact-gallery__grid">
                    {/* Info Side */}
                    <motion.div
                        className="contact-gallery__info"
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="contact-gallery__section-title">
                            CONTACT <span className="contact-gallery__section-title--accent">INFO</span>
                        </h2>

                        <div className="contact-gallery__details">
                            <div className="contact-gallery__detail-item">
                                <div className="contact-gallery__detail-icon">
                                    <MapPin size={28} />
                                </div>
                                <div className="contact-gallery__detail-content">
                                    <h4>Our Location</h4>
                                    <p>
                                        Shop No. 57, Fife Avenue Mall<br />
                                        Corner Fife Ave & Baines Ave<br />
                                        Harare, Zimbabwe
                                    </p>
                                </div>
                            </div>

                            <div className="contact-gallery__detail-item">
                                <div className="contact-gallery__detail-icon">
                                    <Phone size={28} />
                                </div>
                                <div className="contact-gallery__detail-content">
                                    <h4>Call / WhatsApp</h4>
                                    <p><a href="https://wa.me/263781665264" target="_blank" rel="noopener noreferrer" className="hover:text-secondary">+263 781 665 264</a></p>
                                </div>
                            </div>

                            <div className="contact-gallery__detail-item">
                                <div className="contact-gallery__detail-icon">
                                    <Mail size={28} />
                                </div>
                                <div className="contact-gallery__detail-content">
                                    <h4>Email Us</h4>
                                    <p>info@visionsports.com</p>
                                </div>
                            </div>
                        </div>

                        <div className="contact-gallery__socials">
                            <motion.a
                                href="#"
                                className="contact-gallery__social-link"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <Facebook size={24} />
                            </motion.a>
                            <motion.a
                                href="#"
                                className="contact-gallery__social-link"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <Instagram size={24} />
                            </motion.a>
                        </div>
                    </motion.div>

                    {/* Map Side */}
                    <motion.div
                        className="contact-gallery__map-container"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="contact-gallery__map-placeholder">
                            <MapPin size={72} className="contact-gallery__map-icon" />
                            <h3 className="contact-gallery__map-title">FIND US AT FIFE AVENUE</h3>
                            <p className="contact-gallery__map-description">
                                We are located in the heart of Harare, providing accessible elite sports training
                                to youth across the city. Visit us today to explore our facilities.
                            </p>
                            <div className="contact-gallery__map-badge">
                                Google Maps Integration Placement
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>
        </main>
    );
};

export default ContactPage;
